import { messages } from './messages';
import { SKU_SOURCE_UI_VALUES } from '../../../../../utils/sku-source-conversion';

export const DROPDOWN_SETTINGS = [
  {
    settingKey: 'groupBy',
    titleMessage: messages.summarizeBy,
    descriptionMessage: messages.summarizeByDescription,
    items: [
      { key: 'None', messageKey: messages.listEachSeparately },
      { key: 'Both', messageKey: messages.groupBySKUAndName },
      { key: 'SKU', messageKey: messages.groupBySKU },
      { key: 'Name', messageKey: messages.groupByName },
    ],
  },
  {
    settingKey: 'sortBy',
    titleMessage: messages.sortItems,
    descriptionMessage: messages.sortItemsDescription,
    items: [
      {
        key: 'WarehouseLocation',
        messageKey: messages.sortByWarehouseLocation,
      },
      { key: 'Items', messageKey: messages.sortByItems },
      { key: 'SKU', messageKey: messages.sortBySKU },
      { key: 'Name', messageKey: messages.sortByName },
      {
        key: 'WarehouseLocation,SKU',
        messageKey: messages.sortByWarehouseLocationThenSKU,
      },
    ],
  },
  {
    settingKey: 'PickListWarehouseLocation',
    titleMessage: messages.selectLocationSource,
    descriptionMessage: messages.selectLocationSourceDescription,
    items: [
      { key: 'Inventory', messageKey: messages.inventoryLocation },
      { key: 'Shipping', messageKey: messages.shippingLocations },
    ],
  },
  {
    settingKey: 'masterSku',
    titleMessage: messages.skuSource,
    descriptionMessage: messages.skuSourceDescription,
    items: [
      { key: SKU_SOURCE_UI_VALUES.SELLING_CHANNEL, messageKey: messages.sellingChannel },
      { key: SKU_SOURCE_UI_VALUES.SHIPSTATION_CATALOG, messageKey: messages.shipstationProductCatalog },
    ],
  },
];

export const CHECKBOX_SETTINGS = [
  {
    settingKey: 'showImages',
    checkboxId: 'pick-list-product-images',
    titleMessage: messages.productImages,
    descriptionMessage: messages.productImagesDescription,
  },
  {
    settingKey: 'showOrderNumbers',
    checkboxId: 'pick-list-order-numbers',
    titleMessage: messages.orderNumbers,
    descriptionMessage: messages.orderNumbersDescription,
  },
  {
    settingKey: 'hideZeroQuantity',
    checkboxId: 'pick-list-zero-quantity',
    titleMessage: messages.zeroQuantity,
    descriptionMessage: messages.zeroQuantityDescription,
  },
  {
    settingKey: 'showInventoryCounts',
    checkboxId: 'pick-list-inventory-counts',
    titleMessage: messages.inventoryCounts,
    descriptionMessage: messages.inventoryCountsDescription,
  },
  {
    settingKey: 'hideItemOptions',
    checkboxId: 'pick-list-hide-item-options',
    titleMessage: messages.hideItemOptions,
  },
];
